import _jsx from "@babel/runtime/helpers/jsx";
import PropTypes from 'prop-types';
import React from 'react';
var Link = function Link(_ref) {
  var contentState = _ref.contentState,
    _ref$entityKey = _ref.entityKey,
    entityKey = _ref$entityKey === void 0 ? undefined : _ref$entityKey,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? undefined : _ref$children;
  var _contentState$getEnti = contentState.getEntity(entityKey).getData(),
    url = _contentState$getEnti.url;
  return /*#__PURE__*/_jsx("a", {
    className: "md-link",
    href: url,
    rel: "noopener noreferrer",
    target: "_blank",
    "aria-label": url,
    contentEditable: false
  }, void 0, children);
};
export default Link;